const Theme = {
    body_background_color: '#83a195',
    card_background_color: '#fff',
    header_background_color: '#83a195',
    logo_height: 140,
    logo_image_url:'iciterredecarnelle.svg',

    button_radius: 25,
    button_border_width:2,
    button_color: '#F5BB56',
    button_outlined_color: 'white',
    button_text_color: 'black',

    button_half_text_color: '#83a195',
    button_half_border_color: '#F5BB56',

    text_font: 'Modern love - grunge',
    text_color: 'black',

    title_font: 'Modern love - grunge',
    title_weight: 400,
    subtitle_font: 'Modern love - grunge',
}

export default Theme
